<template>
  <div
    class="tip-page-box"
    :class="
      type == 'gley'
        ? 'gley-box'
        : type == 'yellow'
        ? 'yellow-box'
        : type == 'gley-empty'
        ? 'gley-empty-box'
        : ''
    "
  >
    <div
      class="left-icon-box"
      :style="
        type == 'gley-empty' ? 'margin-right:2px' : ''
      "
    >
      <img
        src="@/assets/new-images/tip/gley.svg"
        v-if="type == 'gley' || type == 'gley-empty'"
      />
      <img src="@/assets/new-images/tip/yellow.svg" v-else-if="type == 'yellow'" />
      <img src="@/assets/new-images/tip/primary.svg" v-else />
    </div>
    <div class="right-tip-box">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "blue",
    },
  },
};

</script>

<style scoped lang="scss">
.tip-page-box {
  background: #ebf3ff!important;
  border-radius: 2px;
  padding: 4px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .left-icon-box {
    margin-right: 8px;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4px;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .right-tip-box {
    width: calc(100% - 20px);
    height: fit-content;
    line-height: 22px;
    font-size: 12px;
    color: #666666;
    display: inline-block;
  }
}
.gley-box {
  background: #f4f4f5 !important;
  color: #666;
}
.gley-empty-box {
  background: transparent !important;
  border-color: transparent;
  color: #999;
  padding: 0px;
  .right-tip-box {
    color: #999;
  }
}
.yellow-box {
  background: #fffbe6 !important;
  color: #666;
}
</style>
